import { useState, useCallback } from 'react';

// This hook manages the events in modals i.e Open and close (toggle) and show the loading button
function useModalEvents(openOnStart) {
  const [toggleModal, setToggleModal] = useState(openOnStart ?? false);
  const [loadingButton, setLoadingButton] = useState(false);

  const handleClick = useCallback(() => {
    setToggleModal((state) => !state);
  }, []);

  const handleButtonLoading = () => {
    setLoadingButton((state) => !state);
  };

  return [handleClick, toggleModal, handleButtonLoading, loadingButton];
}
export default useModalEvents;
